import { render, staticRenderFns } from "./EpotStart.vue?vue&type=template&id=72e82ab7&"
import script from "./EpotStart.vue?vue&type=script&lang=js&"
export * from "./EpotStart.vue?vue&type=script&lang=js&"
import style0 from "./EpotStart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports